import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// 初始化 TUIChatKit（TUITranslateService 等），必须在 TUIKit 挂载前执行
import './utils/tUIKitInit'
//按需加载elelement组件
import './ui/index'
// 腾讯云
import VueCompositionAPI from "@vue/composition-api";
Vue.config.productionTip = false
Vue.use(VueCompositionAPI);
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

